import { render, staticRenderFns } from "./novel.vue?vue&type=template&id=a7a7c252"
import script from "./novel.vue?vue&type=script&lang=js"
export * from "./novel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports